<template>
  <e-dialog
    dialog-title="信息确认"
    :center-dialog-visible="verifyVisible"
    :popup-width="'400px'"
    @resetPopupData="resetPopupData"
    @submitPopupData="submitPopupData"
  >
    <div>
      确认后，易派客将开票信息推送至百望平台生成流水单，请提醒贵公司财务人员登录百望平台进行开票。
      是否确认操作？
    </div>
  </e-dialog>
</template>

<script>
import eDialog from '../../../components/common/e-dialog.vue';

export default {
  name: 'ReasonDialog',
  components: { eDialog },
  props: {
    verifyVisible: Boolean,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    resetPopupData() {
      this.$parent.verifyVisible = false;
    },
    submitPopupData() {
      this.$emit('openInvoice');
    },
  },
};
</script>

<style scoped lang="scss"></style>
